import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  schedules: [],
  totalElements: 0,
  createdSchedule: null,
});

const { Types, Creators } = createActions({
  getSchedulesRequest: ['customerId', 'pageParams'],
  getSchedulesRequestSuccess: ['schedules', 'totalElements'],
  getSchedulesRequestFailure: ['errorMessage'],

  createScheduleRequest: ['scheduleInfos', 'customerId', 'pageParams'],
  createScheduleRequestSuccess: ['createdSchedule', 'schedules', 'totalElements', 'successMessage'],
  createScheduleRequestFailure: ['errorMessage'],

  editScheduleRequest: ['scheduleInfos', 'customerId', 'pageParams'],
  editScheduleRequestSuccess: ['schedules', 'totalElements', 'successMessage'],
  editScheduleRequestFailure: ['errorMessage'],

  deleteScheduleRequest: ['scheduleNameId', 'customerId', 'pageParams'],
  deleteScheduleRequestSuccess: ['schedules', 'totalElements', 'successMessage'],
  deleteScheduleRequestFailure: ['errorMessage'],

  resetSchedules: null,
});

export const getSchedulesRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getSchedulesRequestSuccess = (state, { schedules, totalElements }) =>
  state.merge({ isLoading: false, schedules, totalElements });
export const getSchedulesRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const createScheduleRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createScheduleRequestSuccess = (state, { createdSchedule, schedules, totalElements, successMessage }) =>
  state.merge({ isLoading: false, createdSchedule, schedules, totalElements, successMessage });
export const createScheduleRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editScheduleRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editScheduleRequestSuccess = (state, { schedules, totalElements, successMessage }) =>
  state.merge({ isLoading: false, schedules, totalElements, successMessage });
export const editScheduleRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deleteScheduleRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteScheduleRequestSuccess = (state, { schedules, totalElements, successMessage }) =>
  state.merge({ isLoading: false, schedules, totalElements, successMessage });
export const deleteScheduleRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const resetSchedules = (state) => state.merge({ schedules: [], totalElements: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SCHEDULES_REQUEST]: getSchedulesRequest,
  [Types.GET_SCHEDULES_REQUEST_SUCCESS]: getSchedulesRequestSuccess,
  [Types.GET_SCHEDULES_REQUEST_FAILURE]: getSchedulesRequestFailure,

  [Types.CREATE_SCHEDULE_REQUEST]: createScheduleRequest,
  [Types.CREATE_SCHEDULE_REQUEST_SUCCESS]: createScheduleRequestSuccess,
  [Types.CREATE_SCHEDULE_REQUEST_FAILURE]: createScheduleRequestFailure,

  [Types.EDIT_SCHEDULE_REQUEST]: editScheduleRequest,
  [Types.EDIT_SCHEDULE_REQUEST_SUCCESS]: editScheduleRequestSuccess,
  [Types.EDIT_SCHEDULE_REQUEST_FAILURE]: editScheduleRequestFailure,

  [Types.DELETE_SCHEDULE_REQUEST]: deleteScheduleRequest,
  [Types.DELETE_SCHEDULE_REQUEST_SUCCESS]: deleteScheduleRequestSuccess,
  [Types.DELETE_SCHEDULE_REQUEST_FAILURE]: deleteScheduleRequestFailure,

  [Types.RESET_SCHEDULES]: resetSchedules,
});

export const SchedulesTypes = Types;
export default Creators;
